import { jsxs as x, Fragment as N, jsx as e } from "react/jsx-runtime";
import { I as j } from "../chunks/index.ed48ee81.js";
import { m as k } from "../chunks/make-refs.cb0b9b76.js";
import { forwardRef as y } from "react";
import { c as I, s as R } from "../chunks/common.e2f986a6.js";
const q = y(
  ({
    "aria-label": t,
    a11yLabel: o,
    a11yTitle: l,
    className: m,
    hasUnderline: n = !0,
    isDecorative: i = !1,
    icon: a,
    iconPosition: c = "trailing",
    label: f,
    size: p = "medium",
    title: h,
    variant: d = "highlight",
    ...b
  }, u) => {
    const { $el: g } = k(u, ["$el"]), r = {
      "aria-label": t || o,
      title: h || l,
      ref: g,
      className: I({
        className: m,
        hasUnderline: n,
        iconPosition: c,
        size: p,
        variant: d
      }),
      ...b
    }, s = /* @__PURE__ */ x(N, { children: [
      a && /* @__PURE__ */ e(j, { icon: a }),
      /* @__PURE__ */ e("span", { className: R.label, children: f })
    ] });
    return i ? /* @__PURE__ */ e("span", { ...r, children: s }) : r.href ? /* @__PURE__ */ e("a", { ...r, children: s }) : /* @__PURE__ */ e(
      "button",
      {
        type: "button",
        ...r,
        children: s
      }
    );
  }
);
export {
  q as Link
};
//# sourceMappingURL=Link.js.map
